import { execute } from '@/api/execute'
import { GET } from '@/api/types'

const ENDPOINT = 'local'

export default {
  /**
   * Fetchs timezones from a server
   * @returns server response with list of timezones
   */
  timezones () {
    return execute(GET, `${ENDPOINT}/tzs`)
  }
}
